
const projects = [
  {
    id: 1,
    title: "Homsia Prothoma",
    address: "Uttara, Dhaka",
    featured: true,
    bedrooms: "3",
    bathrooms: "2",
    parkings: "1",
    sft: "1200",
    landSize: "5 katha",
    floors: "8",
    apartmentSize: "1200 sft",
    totalApartments: "14",
    totalParking: "8",
    facing: "South",
    roadWidth: "25 ft",
    description:
      "Introducing our astounding real estate venture nestled amidst the serene outskirts of Dhaka, offering modern living spaces harmonizing urban comforts with natural tranquility.",
    status: "sold",
    images: [
      "/assets/projects/prothoma1.JPG",
      "/assets/projects/prothoma2.JPG",
      "/assets/projects/prothoma3.JPG",
    ],
  },
  {
    id: 2,
    title: "Homsia Piar Tower",
    address: "Uttara, Dhaka",
    featured: true,
    bedrooms: "3",
    bathrooms: "2",
    parkings: "1",
    sft: "1200",
    landSize: "4.5 katha",
    floors: "9",
    apartmentSize: "1200 sft",
    totalApartments: "16",
    totalParking: "9",
    facing: "East",
    roadWidth: "20 ft",
    description:
      "Explore our latest real estate project, where modern comfort meets natural charm in every carefully designed home, offering a cozy retreat away from the city bustle.",
    status: "sold",
    images: [
      "/assets/projects/piartower1.JPG",
      "/assets/projects/piartower2.JPG",
      "/assets/projects/piartower3.JPG",
    ],
  },
  {
    id: 3,
    title: "Tranquil Park",
    address: "Sector 13, Jolshiri",
    featured: true,
    bedrooms: "4",
    bathrooms: "4",
    parkings: "1",
    sft: "2850",
    landSize: "5 katha",
    floors: "G+M+8",
    apartmentSize: "2850 sft",
    totalApartments: "8",
    totalParking: "1",
    facing: "",
    roadWidth: "",
    description:
      "Set in the quiet enclave of Sector 13, Jolshiri, Tranquil Park pairs generous 2,850 sft residences with a considered ground-plus-mezzanine tower rising eight storeys. Eight families, one address — a calm, low-density community designed for space, light, and the ease of everyday living.",
    status: "upcoming",
    images: [
      "/assets/projects/tranquil_park/tranquil-park-01.jpg",
      "/assets/projects/tranquil_park/tranquil-park-02.jpg",
      "/assets/projects/tranquil_park/tranquil-park-03.jpg",
      "/assets/projects/tranquil_park/tranquil-park-04.jpg",
      "/assets/projects/tranquil_park/tranquil-park-05.jpg",
    ],
  },
];

export default projects;
